/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { INVOICE_STATUS } from "../constants/constants";
import Badge from "./ui/Badge";
import Icon from "./ui/Icon";

const InvoiceStatusBadge = ({ status, payment_received }) => {
  const statusBadge = {
    [INVOICE_STATUS.PAID]: { title: "invoice_status_paid", color: "success", icon: <Icon.Check size={Icon.SIZE.SM} /> },
    [INVOICE_STATUS.PENDING]: {
      title: "invoice_status_pending",
      color: "neutral",
      icon: <Icon.Clock size={Icon.SIZE.SM} />,
    },
    [INVOICE_STATUS.NEW]: { title: "invoice_status_new", color: "neutral", icon: <Icon.Clock size={Icon.SIZE.SM} /> },
    [INVOICE_STATUS.ERROR]: { title: "invoice_status_error", color: "error", icon: <Icon.Error size={Icon.SIZE.SM} /> },
    [INVOICE_STATUS.CANCELLED]: {
      title: "invoice_status_cancelled",
      color: "error",
      icon: <Icon.Error size={Icon.SIZE.SM} />,
    },
    [INVOICE_STATUS.CANCELLED_BY_TIMEOUT]: {
      title: "invoice_status_cancelled_by_timeout",
      color: "error",
      icon: <Icon.Error size={Icon.SIZE.SM} />,
    },
    [INVOICE_STATUS.REFUNDED]: {
      title: "invoice_status_refunded",
      color: "success",
      icon: <Icon.Check size={Icon.SIZE.SM} />,
    },
  };

  if (status === INVOICE_STATUS.PAID && !payment_received) {
    return <Badge {...statusBadge[INVOICE_STATUS.PENDING]} />;
  }

  return <Badge {...statusBadge[status]} />;
};

export default InvoiceStatusBadge;
